import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Modal from 'modules/core/components/Modal'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import PaymentCompletedModal from 'modules/billing/components/CompletedModal'
import Bill from 'modules/billing/components/PaymentModal/Bill'
import usePlanName from 'modules/billing/hooks/usePlanName'
import plans from 'modules/billing/store/collections/plans'
import subscriptions from 'modules/billing/store/collections/subscriptions'
import Plan from 'modules/billing/store/models/Plan'
import type { Families } from 'modules/billing/store/models/Plan'
import type { IntervalsType } from 'modules/billing/store/models/Plan'

import useUpgradePlan from './useUpgradePlan'

interface Props {
  onClose: () => void
  family: Families
  interval: IntervalsType
}

const UpgradeModalPage = ({ onClose, family, interval }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const planIntervalReadonly = React.useRef(interval === Plan.intervals.year).current

  const [isSuccessful, toggleSuscces] = React.useState(false)
  const subscription = subscriptions.current
  const currentSeats = subscriptions.current.attributes.current_cycle_quantity

  const plan = React.useRef<Plan | undefined>(
    plans.find({
      family,
      interval,
    })
  ).current

  const planName = usePlanName(family)

  const { upgradePlan, onChangePricingPeriod } = useUpgradePlan({
    family,
    plan,
  })

  const { running, performAction: onSubmit } = useAsyncAction(async () => {
    if (!upgradePlan) return

    const { success } = await subscription.rpcChangePlanNow({
      upgradePlan,
    })

    if (success) {
      toggleSuscces(true)
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_saving'),
      })
    }
  })

  return (
    <AuthorizeUser>
      {isSuccessful && (
        <PaymentCompletedModal
          close={() => navigate(navigation.settings.plans.fullPath())}
          cta={i18n.t('billing.completed.cta')}
          description={i18n.t('billing.completed.title')}
          title={i18n.t('billing.completed.pretitle')}
        />
      )}
      {!isSuccessful && upgradePlan && (
        <Modal
          illustration="fireworks"
          title={i18n.t('billing.payment.modal_title', {
            planName,
          })}
          description={i18n.t('billing.upgrade_plan_modal.description')}
          onClose={onClose}
          onSubmit={onSubmit}
          footer={
            <Button disabled={running} submit>
              {i18n.t('billing.your_plan.upgrade.confirm')}
            </Button>
          }
        >
          <Bill
            planIntervalReadonly={planIntervalReadonly}
            plan={upgradePlan}
            planName={planName}
            currentSeats={currentSeats}
            onTogglePricingPeriod={onChangePricingPeriod}
          />
        </Modal>
      )}
    </AuthorizeUser>
  )
}

export default observer(UpgradeModalPage)
